import React from 'react';

const SourceLink = props => {
  return (
    <p  rel="noopener noreferrer" {...props} />
  );
};

export default SourceLink;
